/**
 * Collection class to hold the introspected root type versions for each access to
 * max version of a model when requested.
 */
class VersionMap {
	/**
	 * Construct two maps.
	 * 1. The version/isMax for root type:
	 *      `F_Persons: { version: 0, isMax: false }`
	 *      `F_Persons12: { version: 12, isMax: true }`
	 *      `F_ConstituentPersons: { version: 0, isMax: false }`
	 *      `F_ConstituentPersons15: { version: 15, isMax: true }`
	 * 2. The max version for base type:
	 *       `F_Persons: 12`
	 *       `F_ConstituentPersons: 15`
	 */
	constructor(names) {
		this.rootTypes = new Map();
		this.maxVersionByBaseName = new Map();
		if (!names || !names.length) {
			return;
		}

		names.forEach((name) => {
			let version = 0;
			const matches = name.match(/\d+$/); // ends with number
			if (matches) {
				version = parseInt(matches[0], 10);
			}

			let item = this.rootTypes.get(name);
			if (!item) {
				item = { version, isMax: false };
			}
			this.rootTypes.set(name, item);

			const baseName = version === 0 ? name : name.substring(0, name.lastIndexOf(version.toString()));

			let maxVersion = this.maxVersionByBaseName.get(baseName) || 0;
			if (version > maxVersion) {
				maxVersion = version;
			}
			this.maxVersionByBaseName.set(baseName, maxVersion);
		});

		this.maxVersionByBaseName.forEach((version, baseName) => {
			const item = this.rootTypes.get(baseName + (version || ''));
			if (item) {
				item.isMax = true;
			}
		});
	}

	/**
	 * For the given versioned model name like `F_ModelName12`, return an object with the version number and whether or
	 * not it's the max version.
	 */
	getRootTypeInfo(name) {
		return this.rootTypes.get(name.startsWith('F_') ? name : `F_${name}`);
	}

	/**
	 * For the given unversioned model base name like `F_ModelName`, return the max version name supported such as
	 * `F_ModelName12`.
	 */
	getMaxVersionNameForBaseName(baseName) {
		const version = this.maxVersionByBaseName.get(baseName);
		if (!version) {
			return baseName;
		}
		return baseName + version;
	}

	/**
	 * For the given unversioned model base name like `F_ModelName`, return the max version supported such as
	 * 12.
	 */
	getMaxVersionForBaseName(baseName) {
		return this.maxVersionByBaseName.get(baseName);
	}
}

module.exports = VersionMap;
